import axios from 'axios';
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil';
import {DESATIVAR_USUARIO_PLATAFORMA_WEB} from '../types';
import {URL} from '../../util/ambienteActions';

export default function desativarUsuarioPlataformaWeb(codigo) {
    const url = `${URL}/usuarios/plataforma-web/${codigo}/desativar`;

    return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: DESATIVAR_USUARIO_PLATAFORMA_WEB,
            payload: response
        })
    );
}
